import { render, staticRenderFns } from "./teamPerformanceDetail.vue?vue&type=template&id=40095fd8&scoped=true&"
import script from "./teamPerformanceDetail.vue?vue&type=script&lang=js&"
export * from "./teamPerformanceDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40095fd8",
  null
  
)

export default component.exports